import { useSignal } from "@preact/signals-react";

export class DeleteBlocState {
  showModal = useSignal(false);
  deleteLoading = useSignal(false);
}

export class DeleteBloc {
  constructor(public state: DeleteBlocState) {}

  showDeleteModal() {
    this.state.showModal.value = true;
  }
  handleCancel() {
    if (this.state.deleteLoading.value) return;
    this.state.showModal.value = false;
  }

  getDeleteEventProps(mateData: any, selectedTemplate: any): Record<string, any> {
    const setingUIData = selectedTemplate.v3?.UI?.find((item: any) => {
      return item.id === mateData.id;
    });
    return {
      URL: mateData.link,
      publish_view_name: setingUIData?.title,
      name: setingUIData?.v2App?.appName,
      uuid: mateData.uuid,
    };
  }
}
